import { useSyncExternalStore } from 'react';
import { dismissSuggestion, isNight, nightKey, subscribePreference, suggestionDismissed } from '../../lib/theme';
import { IconMoon } from '../../ui/icons';
import { useNow } from '../../ui/useNow';
import { useTheme } from '../../ui/useTheme';
import styles from './NightSuggestion.module.css';

/**
 * De noche, si la persona nunca eligió tema y está en claro, se ofrece el modo oscuro una vez por noche.
 * Quien eligió «Claro» a propósito no vuelve a verla.
 */
export function NightSuggestion() {
  const { preference, theme, timeZone, setPreference } = useTheme();
  const now = useNow(60_000);
  const key = nightKey(new Date(now), timeZone);
  const dismissed = useSyncExternalStore(subscribePreference, () => suggestionDismissed(key));
  if (preference !== 'system' || theme !== 'light' || dismissed || !isNight(new Date(now), timeZone)) return null;

  return (
    <aside className={styles.toast} aria-label="Sugerencia de modo oscuro">
      <span className={styles.icon} aria-hidden="true"><IconMoon /></span>
      <div className={styles.text}>
        <p className={styles.title}>Ya es de noche</p>
        <p className={styles.body}>¿Activamos el modo oscuro para descansar la vista?</p>
        <div className={styles.actions}>
          <button type="button" className="btn btn-primary" onClick={() => setPreference('dark')}>Activar modo oscuro</button>
          <button type="button" className={`btn ${styles.secondary}`} onClick={() => setPreference('schedule')}>Según la hora</button>
          <button type="button" className="btn btn-quiet" onClick={() => dismissSuggestion(key)}>Ahora no</button>
        </div>
      </div>
    </aside>
  );
}
